import { createEntityAdapter } from '@reduxjs/toolkit'

import { Scenario } from '../models/planning/Scenario'

export const scenariosAdapter = createEntityAdapter({
  selectId: (scenario: Scenario) => scenario.id,
})